/** @module csi/action/ImageGenerate */
define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/middleware/imageTemplates3D/imageGenerateService",
	"csi/sessionConstants",
	"csi/locale",
	"csi/xml"
], function(def, Action, ActionFactory, {isImageGenerateType}, sessionConstants, locale, xml) {

	return ActionFactory.declare("imageGenerateAction", Action, {
		constructor: function() {
			this.m_id = "ActionImageGenerate";
			this.m_tooltip = locale.resource("GenerateImages");
			this.m_typeControl = def.ACTION_ICON;
			this.m_class = "iconImageGenerate";
			this.classController = "csi.action.ImageGenerateController";
			this.m_postAction = "postActionRefresh";
			this.setBaseRights(xml.RIGHT_WRITE);
		},

		/** 
		 * Validate that action is available based on node type.
		 */
		validate: function(ctx) {
			const nodeType = ctx.getContextNode()?.$Type;
			return isImageGenerateType(nodeType) && sessionConstants.allow3d && !ctx.bPrint;
		}
	});
});